(() => {
  const shopRoot = window.Shopify?.routes?.root || '/';
  const fmt = (cents) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' }).format(cents / 100); }
    catch { return '£' + (cents / 100).toFixed(2); }
  };
  const SIZE_TIP = 'Between sizes? Choose the larger one. Our size guide has the measurements.';

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dataEl = root.querySelector('[data-product-json]');
    const form = root.querySelector('[data-product-form]');
    if (!dataEl || !form) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const addBtn = form.querySelector('[data-add]');
    const buyBtn = form.querySelector('[data-buy-now]');
    const message = form.querySelector('[data-form-message]');
    const qty = form.querySelector('[name="quantity"]');
    const fieldsets = [...form.querySelectorAll('[data-option]')];
    const mainImage = root.querySelector('[data-gallery-main]');
    const thumbs = [...root.querySelectorAll('[data-image]')];

    // Size tip under the size buttons
    const sizeValues = form.querySelector('.boo-option-values--size');
    if (sizeValues && !form.querySelector('.boo-size-tip')) {
      const tip = document.createElement('p');
      tip.className = 'boo-size-tip';
      tip.textContent = SIZE_TIP;
      tip.style.cssText = 'font-size:12px;color:#c4b6a3;margin-top:12px;line-height:1.5';
      sizeValues.insertAdjacentElement('afterend', tip);
    }

    const showImage = (button) => {
      if (!mainImage || !button) return;
      mainImage.classList.add('is-changing');
      mainImage.onload = mainImage.onerror = () => mainImage.classList.remove('is-changing');
      mainImage.src = button.dataset.image;
      thumbs.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    };
    thumbs.forEach((button) => button.addEventListener('click', () => showImage(button)));

    const selected = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
    const findVariant = (values) => variants.find((v) => v.options.every((o, i) => o === values[i]));
    // Does any variant use this value, given the options chosen before it?
    const prefixMatch = (v, index, value, values) => v.options[index] === value && v.options.slice(0, index).every((o, i) => o === values[i]);
    const existsWith = (index, value, values) => variants.some((v) => prefixMatch(v, index, value, values));
    const availableWith = (index, value, values) => variants.some((v) => v.available && prefixMatch(v, index, value, values));

    // If the chosen combination isn't made (e.g. a size this design doesn't come in),
    // move to the nearest size that is, preferring in-stock and the larger size.
    function repair() {
      for (let index = 1; index < fieldsets.length; index++) {
        const values = selected();
        const inputs = [...fieldsets[index].querySelectorAll('input')];
        const checked = fieldsets[index].querySelector('input:checked');
        if (checked && existsWith(index, checked.value, values)) continue;
        const pos = checked ? inputs.indexOf(checked) : 0;
        const choices = inputs.filter((i) => existsWith(index, i.value, values));
        if (!choices.length) continue;
        const score = (i) => {
          const k = inputs.indexOf(i);
          return Math.abs(k - pos) + (k < pos ? 0.5 : 0) + (availableWith(index, i.value, values) ? 0 : 100);
        };
        choices.sort((a, b) => score(a) - score(b));
        choices[0].checked = true;
      }
    }

    function markAvailability(values) {
      fieldsets.forEach((fs, index) => {
        fs.querySelectorAll('input').forEach((input) => {
          const label = input.closest('.boo-size-choice');
          const exists = index === 0 || existsWith(index, input.value, values);
          label.style.display = exists ? '' : 'none';
          input.disabled = !exists;
          // only strike through when nothing in stock matches (a design isn't 'sold out' just because the current size isn't made in it)
          label.classList.toggle('is-unavailable', exists && !availableWith(index, input.value, values));
        });
      });
    }

    function update(fromUser) {
      repair();
      const values = selected();
      fieldsets.forEach((fs) => {
        const checked = fs.querySelector('input:checked');
        const out = fs.querySelector('[data-option-value]');
        if (out && checked) out.textContent = checked.dataset.label || checked.value;
      });
      markAvailability(values);
      const variant = findVariant(values);
      if (!variant) {
        addBtn.disabled = true; buyBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.unavailableLabel;
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = fmt(variant.price);
      if (compareEl) {
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = fmt(variant.compare_at_price);
      }
      addBtn.disabled = !variant.available; buyBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.dataset.addLabel : addBtn.dataset.soldLabel;
      if (fromUser) {
        if (variant.featured_media) showImage(thumbs.find((b) => b.dataset.mediaId === String(variant.featured_media.id)));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    fieldsets.forEach((fs) => fs.querySelectorAll('input').forEach((input) => input.addEventListener('change', () => update(true))));
    update(false);

    root.querySelectorAll('[data-quantity]').forEach((button) => button.addEventListener('click', () => {
      qty.value = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.quantity)));
    }));

    async function add(buy) {
      if (!idInput.value) return;
      const buttons = [addBtn, buyBtn];
      const was = buttons.map((b) => b.disabled);
      buttons.forEach((b) => { b.disabled = true; });
      message.textContent = '';
      try {
        const response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qty.value) || 1 }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || message.dataset.error);
        if (buy) { window.location.assign(shopRoot + 'checkout'); return; }
        message.textContent = message.dataset.success;
        const cart = await fetch(shopRoot + 'cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      } catch (error) {
        message.textContent = error.message || message.dataset.error;
      } finally {
        buttons.forEach((b, i) => { b.disabled = was[i]; });
      }
    }
    form.addEventListener('submit', (e) => { e.preventDefault(); add(false); });
    buyBtn.addEventListener('click', () => add(true));

    root.querySelectorAll('[data-open-details]').forEach((link) => link.addEventListener('click', () => {
      const target = root.querySelector(link.getAttribute('href'));
      if (target) target.open = true;
    }));
  }

  document.querySelectorAll('[data-boo-product]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-boo-product]')));
})();
